import { trackEvent } from '../../functions/google';
import { maybeConvertAmount } from '../../functions/currency';

/**
 * Google (GA4 / gtag / dataLayer) events for the upsell flow.
 *
 * An accepted upsell fires an incremental purchase carrying only the upsell's
 * own value. The transaction_id must be the upsell line item id: GA4
 * deduplicates purchases by transaction_id, so reusing the checkout id would
 * drop this event.
 */
window.addEventListener('scUpsellAccepted', (e) => {
  const { checkout, line_item: lineItem, product } = e.detail;

  trackEvent('purchase', {
    transaction_id: lineItem?.id,
    value: maybeConvertAmount(lineItem?.total_amount || 0, checkout?.currency || 'USD'),
    currency: (checkout?.currency || '').toUpperCase(),
    items: [
      {
        item_id: product?.id,
        item_name: product?.name || '',
        currency: (checkout?.currency || '').toUpperCase(),
        discount: lineItem?.discount_amount ? maybeConvertAmount(lineItem?.discount_amount || 0, checkout?.currency || 'USD') : 0,
        price: maybeConvertAmount(lineItem?.total_amount || 0, checkout?.currency || 'USD'),
        quantity: lineItem?.quantity || 1,
        ...(lineItem?.variant_options?.length ? { item_variant: (lineItem.variant_options || []).join(' / ') } : {}),
      },
    ],
  });
});
